<template>
  <div class="courseware_main">
    <div class="courseware_name">
      {{ courseData.courseName }}
    </div>
    <div class="courseware_info">
      <div>类型：{{ courseData.courseTypeName }}</div>
      <div>课时：{{ courseData.classHour }}课时</div>
      <div>发布时间：{{ courseData.createTime }}</div>
    </div>

    <!-- 手机端：固定播放器区域 -->
    <div class="mobile-player-fixed" v-if="isMobile" ref="playerFixed">
      <div class="player-container">
        <VideoPlay ref="videoPlayer1" :videoUrl="videoUrl" poster="https://example.com/poster.jpg" :controls="true"
          :autoplay="false" @play="handlePlay" @pause="handlePause" @ended="handleEnded" @timeupdate="onTimeupdate"
          v-if="resourceType == 2" />
        <ImagePreview :src="courseImage" alt="" width="100%" v-if="resourceType == 1" />
        <div v-if="resourceType != 1 && resourceType != 2 && resourceType != ''" v-cloak>
          <el-button @click="toggleFullscreen">
            {{ isFullscreen ? '退出全屏' : '全屏' }}
          </el-button>
          <iFrame :src="wpsUrl" :fullscreen.sync="isFullscreen"></iFrame>
        </div>

        <div v-if="resourceType == ''" class="noData">
          暂无资源
        </div>
      </div>
    </div>

    <div class="courseware_content">
      <!-- PC端左侧播放器 -->
      <div class="courseware_left" v-if="!isMobile">
        <VideoPlay ref="videoPlayer1" :videoUrl="videoUrl" poster="https://example.com/poster.jpg" :controls="true"
          :autoplay="false" @play="handlePlay" @pause="handlePause" @ended="handleEnded" @timeupdate="onTimeupdate"
          v-if="resourceType == 2" />
        <ImagePreview :src="courseImage" alt="" width="100%" v-if="resourceType == 1" />
        <div v-if="resourceType != 1 && resourceType != 2 && resourceType != ''">
          <el-button @click="toggleFullscreen">
            {{ isFullscreen ? '退出全屏' : '全屏' }}
          </el-button>
          <iFrame :src="wpsUrl" :fullscreen.sync="isFullscreen"></iFrame>
        </div>

        <div v-if="resourceType == ''" class="noData">
          暂无资源
        </div>
      </div>

      <!-- 右侧目录区域（可滚动） -->
      <div class="courseware_right" :class="{ 'mobile-right': isMobile }">
        <div v-if="isMobile && showPlaceholder" class="mobile-placeholder" :style="{ height: playerHeight + 'px' }">
        </div>

        <div v-if="coursewareList.length > 0">
          <el-collapse v-model="activeName" accordion v-for="item in coursewareList" :key="item.id"
            @change="getCollapse">
            <el-collapse-item :title="item.catalogName" :name="item.id">
              <div v-for="dict in item.fileList" :key="dict.id" class="fileName" @click="getOfficeView(dict)"
                :class="{ 'active': activeId == dict.id }">
                <div class="name">
                  {{ dict.courseWreName }}
                </div>
                <div>
                  <el-progress :percentage="dict.progress"></el-progress>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="noData" v-else>
          暂无目录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseDetail, getCoursewareList, getStudyRecord } from '@/api/courseModel/index'
import base from '@/api/base.js'
// import VideoPlay from '@/components/VideoPlay/index.vue'
// import ImagePreview from '@/components/ImagePreview/index.vue'
// import iFrame from '@/components/iFrame/index.vue'

export default {
  name: 'CoursewareDetail',
  // components: { VideoPlay, ImagePreview, iFrame },
  data() {
    return {
      activeName: '1',
      activeId: '',
      wpsUrl: "",
      isFullscreen: false,
      courseImage: '',
      videoUrl: '',
      courseData: {},
      coursewareList: [],
      timer: 0,
      intervalId: null,
      resourceType: '',
      clockTime: 0,
      wareId: '',
      state: 0,
      isMobile: false,
      playerHeight: 0,
      scrollTop: 0,
      isPlayerFixed: false,

      // 优化：合并视频相关变量
      videoProgress: {
        currentTime: 0,        // 当前已观看时间（秒）
        requiredDuration: 0,    // 需要学习的时长（秒）
        isCompleted: false,     // 是否已完成学习
        isPlaying: false,       // 是否正在播放
        wareId: '',            // 当前课件ID
        lastSaveTime: 0,        // 上次保存的时间点
        saveThreshold: 5        // 保存阈值（秒），每5秒保存一次
      }
    };
  },
  computed: {
    showPlaceholder() {
      return this.isMobile && this.isPlayerFixed && this.playerHeight > 0;
    }
  },
  watch: {
    resourceType: {
      handler() {
        this.$nextTick(() => {
          this.updatePlayerHeight();
        });
      }
    }
  },
  created() {
    this.checkMobile();
    this.getCourseDetail();
    this.getCoursewareList();
  },
  mounted() {
    window.addEventListener('resize', this.checkMobile);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    this.stopTimer();
    window.removeEventListener('resize', this.checkMobile);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.saveProgressImmediately();
  },
  methods: {
    // 检查是否为手机端
    checkMobile() {
      this.isMobile = window.innerWidth < 1060;
      if (this.isMobile) {
        this.$nextTick(() => {
          this.updatePlayerHeight();
        });
      }
    },

    // 更新播放器高度
    updatePlayerHeight() {
      if (this.isMobile && this.$refs.playerFixed) {
        const playerElement = this.$refs.playerFixed;
        this.playerHeight = playerElement.offsetHeight;
      }
    },

    // 处理滚动
    handleScroll() {
      if (!this.isMobile) return;

      const playerFixed = this.$refs.playerFixed;
      if (!playerFixed) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollTop = scrollTop;

      if (scrollTop > 100) {
        playerFixed.classList.add('fixed');
        this.isPlayerFixed = true;

        this.$nextTick(() => {
          this.updatePlayerHeight();
        });
      } else {
        playerFixed.classList.remove('fixed');
        this.isPlayerFixed = false;
        this.playerHeight = 0;
      }
    },

    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },

    // 详情接口
    getCourseDetail() {
      getCourseDetail(this.$route.query.id).then((res) => {
        this.courseData = res.data;
      })
    },

    // 详情-课件列表
    getCoursewareList() {
      getCoursewareList(this.$route.query.id).then((res) => {
        this.coursewareList = res.data
        if (res.data.length > 0 && res.data[0].fileList.length > 0) {
          this.activeName = res.data[0].id;
          this.activeId = res.data[0].fileList[0].id;
          this.getOfficeView(res.data[0].fileList[0])
        }
      })
    },

    // 折叠下拉时间监听
    getCollapse(val) {
      this.activeName = val;
    },

    // 点击资源预览
    getOfficeView(dict) {
      // 切换课件前保存当前进度
      if (this.videoProgress.wareId && this.videoProgress.currentTime > 0) {
        this.saveProgressImmediately();
      }

      // 停止所有计时器
      this.stopTimer();

      this.activeId = dict.id;
      this.resourceType = dict.courseWareType;

      // 计算需要学习的总时长（秒）
      const requiredDuration = (dict.requiredDurationMinute || 0) * 60 + (dict.requiredDurationSecond || 0);

      // 重置视频进度对象
      this.videoProgress = {
        currentTime: dict.duration || 0,
        requiredDuration: requiredDuration,
        isCompleted: (dict.duration || 0) >= requiredDuration && requiredDuration != 0,
        isPlaying: false,
        wareId: dict.id,
        lastSaveTime: dict.duration || 0,
        saveThreshold: 5
      };
      // console.log(this.videoProgress)

      if (this.resourceType == 1) {
        this.courseImage = base.resourceUrl + dict.courseWareUrl;
        // 非视频资源直接开始计时
        if (!this.videoProgress.isCompleted) {
          this.startTimer(this.videoProgress.currentTime, this.videoProgress.requiredDuration);
        }
      } else if (this.resourceType == 2) {
        this.videoUrl = base.resourceUrl + dict.courseWareUrl;
      } else {
        this.wpsUrl = "/pv.html?fileUrl=" + dict.courseWareOfficeName
        // 非视频资源直接开始计时
        if (!this.videoProgress.isCompleted) {
          this.startTimer(this.videoProgress.currentTime, this.videoProgress.requiredDuration);
        }
      }

      // 更新播放器高度
      this.$nextTick(() => {
        this.updatePlayerHeight();
      });
    },

    // 统一的计时器
    startTimer(startTime, endTime) {
      // 如果已经学完，不启动计时器
      if (this.videoProgress.isCompleted) {
        // console.log('该课件已完成学习，不启动计时器');
        return;
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      this.videoProgress.currentTime = startTime || 0;
      this.videoProgress.lastSaveTime = startTime || 0;

      this.intervalId = setInterval(() => {
        if (this.videoProgress.currentTime >= endTime) {
          // 学习完成
          this.videoProgress.currentTime = endTime;
          this.videoProgress.isCompleted = true;
          // console.log('学习完成，总时长:', endTime);
          this.stopTimer();
          this.saveProgressImmediately();
        } else {
          this.videoProgress.currentTime++;
          // console.log(this.videoProgress.currentTime)
          // 每5秒自动保存一次
          // if (this.videoProgress.currentTime - this.videoProgress.lastSaveTime >= this.videoProgress.saveThreshold) {
          //   this.saveProgressImmediately();
          //   this.videoProgress.lastSaveTime = this.videoProgress.currentTime;
          // }
        }
      }, 1000);
    },

    // 停止计时器
    stopTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    // 立即保存进度
    // saveProgressImmediately() {
    //   if (!this.videoProgress.wareId || this.videoProgress.currentTime <= 0) return;

    //   // 如果已经完成且currentTime已经等于requiredDuration，不重复保存
    //   if (this.videoProgress.isCompleted && this.videoProgress.currentTime > this.videoProgress.requiredDuration) {
    //     return;
    //   }

    //   const param = {
    //     wareId: this.videoProgress.wareId,
    //     studyDuration: Math.floor(this.videoProgress.currentTime) // 取整
    //   };

    //   getStudyRecord(param).then((res) => {
    //     console.log('进度保存成功:', this.videoProgress.currentTime);
    //     this.videoProgress.lastSaveTime = this.videoProgress.currentTime;
    //     this.getCoursewareLists(); // 刷新列表进度
    //   }).catch(err => {
    //     console.error('进度保存失败:', err);
    //   });
    // },
    // 立即保存进度
    saveProgressImmediately() {
      if (!this.videoProgress.wareId || this.videoProgress.currentTime < 0 && this.videoProgress.requiredDuration != 0) return;

      // 计算需要学习的总时长
      const requiredDuration = this.videoProgress.requiredDuration;
      const currentTime = this.videoProgress.currentTime;

      // 情况1：已经完成学习（currentTime >= requiredDuration）
      if (currentTime >= requiredDuration && requiredDuration != 0) {
        // 如果已经标记为完成，但还没保存过最终进度，需要保存
        // 通过比较 lastSaveTime 和 requiredDuration 来判断是否已保存最终进度
        if (this.videoProgress.lastSaveTime < requiredDuration) {
          // console.log('学习完成，保存最终进度');
          // 继续执行保存
        } else {
          // 已经保存过最终进度，不再重复保存
          return;
        }
      }

      // 情况2：还没学完，但需要保存中间进度
      // 如果上次保存时间等于当前时间，说明已经保存过，不再重复保存
      if (this.videoProgress.lastSaveTime === currentTime && currentTime != 0) {
        return;
      }

      const param = {
        wareId: this.videoProgress.wareId,
        studyDuration: Math.floor(currentTime) // 取整
      };

      getStudyRecord(param).then((res) => {
        // console.log('进度保存成功:', currentTime);
        this.videoProgress.lastSaveTime = currentTime;

        // 如果当前时间已达到要求时长，标记为完成
        if (currentTime >= requiredDuration) {
          this.videoProgress.isCompleted = true;
        }

        this.getCoursewareLists(); // 刷新列表进度
      }).catch(err => {
        console.error('进度保存失败:', err);
      });
    },

    // 课件列表保存查询
    getCoursewareLists() {
      getCoursewareList(this.$route.query.id).then((res) => {
        this.coursewareList = res.data;
        // 更新当前课件的完成状态
        const currentWare = this.findCurrentWareInList();
        // console.log(currentWare)
        if (currentWare) {
          this.videoProgress.isCompleted = (currentWare.duration || 0) >= this.videoProgress.requiredDuration;
          this.videoProgress.currentTime = currentWare.duration || 0;
        }
      });
    },

    // 在列表中查找当前课件
    findCurrentWareInList() {
      for (const catalog of this.coursewareList) {
        const found = catalog.fileList.find(item => item.id === this.videoProgress.wareId);
        if (found) return found;
      }
      return null;
    },

    // 页面关闭前保存
    handleBeforeUnload() {
      this.saveProgressImmediately();
    },

    // 视频播放事件处理
    handlePlay() {
      // console.log('视频开始播放');
      this.videoProgress.isPlaying = true;

      // 检查是否已完成
      if (this.videoProgress.isCompleted) {
        console.log('该课件已完成学习，停止计时');
        return;
      }

      // 如果当前进度小于需要学习的时长，开始计时
      if (this.videoProgress.currentTime <= this.videoProgress.requiredDuration) {
        this.startTimer(this.videoProgress.currentTime, this.videoProgress.requiredDuration);
      }
    },

    handlePause() {
      console.log('视频暂停');
      this.videoProgress.isPlaying = false;
      this.saveProgressImmediately();
      this.videoProgress.lastSaveTime = this.videoProgress.currentTime;

      // 暂停时保存进度
      if (this.videoProgress.currentTime < this.videoProgress.requiredDuration) {
        this.stopTimer();
        this.saveProgressImmediately();
      }
    },

    handleEnded() {
      // console.log('视频播放结束');
      // this.videoProgress.isPlaying = false;

      // // 结束时的处理
      // this.stopTimer();

      // // 如果当前进度小于需要学习的时长，说明视频提前结束
      // if (this.videoProgress.currentTime < this.videoProgress.requiredDuration) {
      //   console.log('视频提前结束，当前进度:', this.videoProgress.currentTime);
      // }

      // // 保存最终进度
      // this.saveProgressImmediately();
    },

    // timeupdate事件处理
    onTimeupdate({ currentTime, duration }) {
      // 更新当前播放时间（来自视频的实际播放进度）
      // 这里只记录，不用于计时，计时由单独的计时器负责
      // console.log(`视频实际进度: ${currentTime}/${duration}`);

      // 如果需要同步视频进度和学习进度，可以在这里做
      // 但注意不要频繁操作
      if (this.videoProgress.isPlaying && !this.videoProgress.isCompleted) {
        // 可以用视频实际进度来校准学习进度，但需要避免频繁更新
        // 这里简单记录，不做实际处理
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.courseware_main {
  margin-top: 1rem;
  margin-left: 100px;
  margin-right: 100px;
  min-height: calc(100vh - 74px - 180px);

  @media(max-width: 1060px) {
    margin-left: 0px;
    margin-right: 0px;
    padding: 10px;
    position: relative;
  }

  .courseware_name {
    font-size: 28px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width: 1060px) {
      font-size: 20px;
      padding: 0 10px;
    }
  }

  .courseware_info {
    display: flex;
    font-size: 18px;
    height: 36px;
    background: #f5f5f5;
    margin: 20px 0;
    justify-content: space-around;
    align-items: center;

    @media(max-width: 1060px) {
      display: block;
      height: auto;
      width: 100%;
      background: transparent;
      margin: 10px 0;

      &>div {
        background: #f5f5f5;
        margin: 10px 0;
        height: 36px;
        line-height: 36px;
        text-indent: 10px;
        font-size: 14px;
      }
    }
  }

  // 手机端固定播放器
  .mobile-player-fixed {
    display: none;

    @media(max-width: 1060px) {
      display: block;
      width: 100%;
      background: #fff;
      z-index: 100;
      transition: all 0.3s ease;

      &.fixed {
        position: fixed;
        top: 70px;
        left: 0;
        right: 0;
        padding: 10px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        animation: slideDown 0.3s ease;
      }

      .player-container {
        width: 100%;
        background: #000;
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        ::v-deep .video-js {
          width: 100%;
          height: auto;
          aspect-ratio: 16/9;
        }

        ::v-deep .image-preview {
          width: 100%;
          height: auto;
          aspect-ratio: 16/9;
          object-fit: contain;
          background: #f5f5f5;
        }

        ::v-deep iframe {
          width: 100%;
          height: 50vh;
          min-height: 300px;
          border: none;
        }

        .noData {
          height: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          background: #f5f5f5;
        }

        .el-button {
          position: absolute;
          top: 20px;
          right: 20px;
          z-index: 10;
        }
      }
    }
  }

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }

    to {
      transform: translateY(0);
    }
  }

  .courseware_content {
    display: flex;

    @media(max-width: 1060px) {
      display: block;
      width: 100%;
    }

    .courseware_left {
      flex: 1;
      overflow: hidden;

      @media(max-width: 1060px) {
        display: none;
      }

      .noData {
        height: 930px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
      }
    }

    .courseware_right {
      width: 420px;
      padding-left: 40px;

      @media(max-width: 1060px) {
        width: 100%;
        padding-left: 0px;
      }

      &.mobile-right {
        .mobile-placeholder {
          width: 100%;
          background: transparent;
          transition: height 0.3s ease;
        }
      }

      .fileName {
        border: 1px solid #f5f5f5;
        padding: 10px;
        margin-top: 10px;
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        border-radius: 4px;

        @media(max-width: 1060px) {
          font-size: 16px;
          padding: 8px;
        }

        .name {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-bottom: 8px;

          @media(max-width: 1060px) {
            font-size: 14px;
          }
        }

        ::v-deep .el-progress {
          .el-progress-bar__outer {
            background-color: #f0f0f0;
          }

          .el-progress-bar__inner {
            background-color: #409EFF;
          }

          .el-progress__text {
            font-size: 12px !important;
          }
        }
      }

      .active {
        color: #409EFF;
        border-color: #409EFF;
      }

      .noData {
        height: 930px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;

        @media(max-width: 1060px) {
          height: 230px;
          font-size: 18px;
        }
      }
    }
  }
}

:fullscreen {
  .mobile-player-fixed {
    display: none;
  }
}

:-webkit-full-screen {
  .mobile-player-fixed {
    display: none;
  }
}
</style>